import React, { forwardRef, useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../hooks/useBreakpoint";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
var ParallaxContainer = styled.div.withConfig({
  componentId: "sc-1ofpzp0-0"
})(function (_ref) {
  var $isParallaxDisabled = _ref.$isParallaxDisabled;
  return css(["display:grid;grid-gap:", ";grid-template-columns:1fr;justify-content:space-between;width:100%;max-width:", ";margin:auto;overflow:hidden;@media (max-width:1919.8px){max-width:", ";}", "{grid-gap:", ";grid-template-columns:1fr 1fr;}", "{grid-gap:", ";grid-template-columns:repeat(3,1fr);}", ";"], space(3), unit(1280), unit(1112), breakpoint("medium", "large"), space(6), breakpoint("large"), space(8), $isParallaxDisabled && css(["padding-bottom:", ";"], unit(300)));
});
var Column = styled.div.withConfig({
  componentId: "sc-1ofpzp0-1"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;gap:", ";", "{gap:", ";}", "{gap:", ";}&:nth-child(1){margin-bottom:-", ";", "{margin-top:", ";margin-bottom:-", ";}}&:nth-child(2){margin-top:", ";", "{margin-top:", ";}", "{margin-bottom:-", ";}}"], space(5), breakpoint("medium", "large"), space(9), breakpoint("large"), space(12), space(30), breakpoint("medium", "large"), space(12), space(32), space(12), breakpoint("medium", "large"), space(0), breakpoint("large"), space(10));
var ParallaxOrg = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var scrollContainerRef = _ref2.scrollContainerRef,
    isAnimationActive = _ref2.isAnimationActive,
    children = _ref2.children;
  var middleColumnRef = useRef(null);
  var leftColumnRef = useRef(null);
  var rightColumnRef = useRef(null);
  var isMobile = useBreakpoint("small", "medium");
  var isMedium = useBreakpoint("medium", "large");
  var mediumUpColumns = isMedium ? 2 : 3;
  var numColumns = isMobile ? 1 : mediumUpColumns;
  var isParallaxEffectEnabled = children.length > 9;
  useEffect(function () {
    gsap.registerPlugin(ScrollTrigger);
    if (isAnimationActive && isParallaxEffectEnabled) {
      // Left Column Animation

      gsap.to(leftColumnRef.current, {
        ease: "none",
        y: -300,
        scrollTrigger: {
          trigger: leftColumnRef.current,
          start: "top top",
          end: "bottom bottom",
          scroller: scrollContainerRef,
          scrub: 1
        }
      });
      if (numColumns > 1) {
        // Middle Column Animation
        gsap.to(middleColumnRef.current, {
          ease: "none",
          y: -100,
          scrollTrigger: {
            trigger: middleColumnRef.current,
            start: "top top",
            end: "bottom bottom",
            scroller: scrollContainerRef,
            scrub: 1
          }
        });
      }
      if (numColumns > 2) {
        // Right Column Animation
        gsap.to(rightColumnRef.current, {
          ease: "none",
          y: -300,
          scrollTrigger: {
            trigger: rightColumnRef.current,
            start: "top top",
            end: "bottom bottom",
            scroller: scrollContainerRef,
            scrub: 1
          }
        });
      }
    }
  }, [isAnimationActive, scrollContainerRef, numColumns]);
  var elements = React.Children.toArray(children);
  var columns = Array.from({
    length: numColumns
  }, function (_, columnIndex) {
    return elements.filter(function (__, index) {
      return index % numColumns === columnIndex;
    });
  });
  var columnRefs = [leftColumnRef, middleColumnRef, rightColumnRef];
  var columnElements = columns.map(function (column, columnIndex) {
    return /*#__PURE__*/React.createElement(Column
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: "column-".concat(columnIndex),
      ref: columnRefs[columnIndex]
    }, column);
  });
  return /*#__PURE__*/React.createElement(ParallaxContainer, {
    $isParallaxDisabled: !isParallaxEffectEnabled,
    ref: ref
  }, columnElements);
});
export default ParallaxOrg;